import { render, staticRenderFns } from "./AlliancePage.vue?vue&type=template&id=b868e6c2&scoped=true&"
import script from "./AlliancePage.vue?vue&type=script&lang=js&"
export * from "./AlliancePage.vue?vue&type=script&lang=js&"
import style0 from "./AlliancePage.vue?vue&type=style&index=0&id=b868e6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b868e6c2",
  null
  
)

export default component.exports